(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('national-brokerage', {
            parent: 'entity',
            url: '/national-brokerage?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.nationalBrokerage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/national-brokerage/national-brokerages.html',
                    controller: 'NationalBrokerageController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nationalBrokerage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('national-brokerage-detail', {
            parent: 'entity',
            url: '/national-brokerage/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.nationalBrokerage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/national-brokerage/national-brokerage-detail.html',
                    controller: 'NationalBrokerageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nationalBrokerage');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'NationalBrokerage', function($stateParams, NationalBrokerage) {
                    return NationalBrokerage.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('national-brokerage.new', {
            parent: 'national-brokerage',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/national-brokerage/national-brokerage-dialog.html',
                    controller: 'NationalBrokerageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('national-brokerage', null, { reload: true });
                }, function() {
                    $state.go('national-brokerage');
                });
            }]
        })
        .state('national-brokerage.edit', {
            parent: 'national-brokerage',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/national-brokerage/national-brokerage-dialog.html',
                    controller: 'NationalBrokerageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NationalBrokerage', function(NationalBrokerage) {
                            return NationalBrokerage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('national-brokerage', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('national-brokerage.delete', {
            parent: 'national-brokerage',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/national-brokerage/national-brokerage-delete-dialog.html',
                    controller: 'NationalBrokerageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NationalBrokerage', function(NationalBrokerage) {
                            return NationalBrokerage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('national-brokerage', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
